module.exports = __webpack_public_path__ + "static/media/check.8e15275a.svg";